import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import {Toast} from 'primereact/toast';
import * as actions from '../../store/actions/index';
import Messages from '../../shared/UI/Messages/Messages';
import { IS_SIGNED_IN } from '../../shared/utility';

class SignInAr extends Component{

    state = {
        username : '',//10469
        password : ''
    }

    handleSubmit = () => {
        if(this.state.username && this.state.password){
            this.props.onAuth(this.state.username, this.state.password,true, false);     
        } else {
            this.growl.show({severity: 'error', summary: null, detail: 'الرجاء إدخال اسم المستخدم وكلمة المرور'});     
        }
    }

    render(){
        // Gated on IS_SIGNED_IN rather than on the token, which is non-null before
        // anyone logs in (see there) — that sent this screen to the dashboard on a
        // cold load, before any credentials were entered.
        let redirectUrl = null
        if(this.props.signedIn){
            const defaultPage = this.props.authResponse && this.props.authResponse.defaultpage;

            if (defaultPage) {
                // The default page this user's own authentication response named.
                redirectUrl = <Redirect to={defaultPage}/>
            } else {
                // No default page on the response — the role-based screens this
                // login has always fallen back to.
                redirectUrl = <Redirect to="/dashboard"/>
                const userrole = localStorage.getItem('UserRole');
                if (userrole == "80" || userrole == "85" || userrole == "90"){
                    redirectUrl = <Redirect to="/dashboardservice"/> ;
                }
            }
        }

        return(
            <div className="signin-container">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                <Toast ref={(el) => this.growl = el} />
                {redirectUrl}
                <h2 className="login-title">تسجيل الدخول عن طريق معرف المستخدم</h2>
                <form className="login-form" onSubmit={e => {e.preventDefault();}}>
                    <fieldset>
                        <label htmlFor="username" className="username login-label">اسم المستخدم</label>
                        <input type="text" name="username" id="username" placeholder="أدخل اسم المستخدم" value={this.state.username} className="login-control" autoComplete="off" onChange={(e) => this.setState({username: e.target.value})}/>
                    </fieldset>
                    <fieldset>
                        <label htmlFor="password" className="password login-label">كلمة المرور</label>
                        <input type="password" name="password" id="password" placeholder="أدخل كلمة المرور" value={this.state.password} className="login-control" autoComplete="off" onChange={(e) => this.setState({password: e.target.value})} />
                    </fieldset>
                    <fieldset>
                        <input type="submit" value="تسجيل الدخول" name="submit" id="login" className="login-button" onClick={this.handleSubmit} />
                    </fieldset>
                </form>
            </div>
        );

    }


}

const mapStateToProps = state => {
    return {
        error : state.auth.error,
        loading : state.auth.loading,
        signedIn : IS_SIGNED_IN(state.auth),
        authResponse : state.auth.userPosInfo,
    }
}

const mapDispatchToProps = dispatch => {
    return{
        onAuth : (email, password,Ar, isSignUp) => dispatch(actions.auth(email, password,Ar, isSignUp)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignInAr);